import { render, staticRenderFns } from "./AddResort.vue?vue&type=template&id=b59a60a0&"
import script from "./AddResort.vue?vue&type=script&lang=js&"
export * from "./AddResort.vue?vue&type=script&lang=js&"
import style0 from "./AddResort.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports